import React from 'react';
import { Typography } from '@mui/material';

interface InlineErrorProps {
  message: string;
  id?: string;
}

const InlineError: React.FC<InlineErrorProps> = ({ message, id }) => {
  return (
    <div role="alert" aria-live="assertive" id={id} style={{ marginTop: '0.75rem' }}>
      <Typography variant="body2" color="error">{message}</Typography>
    </div>
  );
};

export default InlineError;
